import { Reveal } from "./Reveal";
import { SERVICES } from "@/data";
import { Lightbulb, LayoutGrid, Boxes, Wrench, Grip, Truck } from "lucide-react";

const ICONS = { Lightbulb, LayoutGrid, Boxes, Wrench, Grip, Truck };

export const Services = () => (
  <section id="services" className="bg-surface py-24 lg:py-32 border-y border-ink/10">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
        <Reveal className="lg:col-span-8">
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-rust">Optional Upgrades</span>
          <h2 className="mt-5 font-display font-black tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            Go further while we're already there.
          </h2>
        </Reveal>
        <Reveal className="lg:col-span-4" delay={0.1}>
          <p className="text-lg text-ink/60 leading-relaxed">
            Add any of these when you book. We arrive with the materials in the truck and install everything before we leave.
          </p>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-ink/10 border border-ink/10">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal key={s.title} delay={(i % 3) * 0.08}>
              <div data-testid={`service-${i}`} className="group bg-surface h-full p-8 hover:bg-rust transition-colors duration-300">
                <div className="w-12 h-12 border border-ink/15 grid place-items-center text-ink group-hover:text-white group-hover:border-white/30 transition-colors">
                  <Icon size={22} />
                </div>
                <h3 className="mt-6 font-display font-bold text-2xl text-ink group-hover:text-white transition-colors">{s.title}</h3>
                <p className="mt-3 text-ink/60 group-hover:text-white/85 leading-relaxed transition-colors">{s.body}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
